<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <div class="iq-edit-list-data">
          <tab-content id="pills-tabContent-2">
            <tab-content-item :active="true" id="quickQuote">
              <iq-card>
                <template v-slot:body>
                  <div v-if="leadSource == 'RDL'">
                    <h4>Refer Dealer Leads</h4>
                  </div>

                  <appQuoteStepNew
                    :propsMode="propsMode"
                    :quoteType="quoteType"
                    :leadSource="leadSource"
                  ></appQuoteStepNew>
                </template>
              </iq-card>
            </tab-content-item>
          </tab-content>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import * as taxTableService from '../../services/taxTable.service'
import appQuoteStepNew from '../../components/quote/step1.vue'

export default {
  name: 'quoteNew',
  props: ['propsMode', 'quoteType', 'leadSource'],
  components: {
    appQuoteStepNew
  },
  created() {
    // Store taxTable information in local storage
    taxTableService.storeTaxTable()
  }
}
</script>
